module.exports = [{
      plugin: require('/zeit/14c165e9/node_modules/gatsby-plugin-preact/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/zeit/14c165e9/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#222222","theme_color":"#222222","display":"minimal-ui","icon":"src/images/gatsby-icon.png"},
    },{
      plugin: require('/zeit/14c165e9/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/zeit/14c165e9/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
